import {TextSelection} from "prosemirror-state";
import React from "react";
import intl from "react-intl-universal";
import {useRootStore} from "@stores/AppStateContext";

import {TriggerActionsProps} from "./TriggerActions";
import {insertMention} from "../../../../../Editor/module/commands/triggers/insertMention";

import {ContextMenuInEditor} from '../../../../components/ContextMenuInEditor';


import { editorViewRef } from '../../../../elements/EditorReact';


export const TriggerMentions = ({textInput, handleClose, isDark, nodePos}: TriggerActionsProps) => {
    const rootStore = useRootStore();
    const view = editorViewRef.current!;
    const allItems = rootStore.view.workspace!.items.values();

    const visibleItems = [];

    for (const item of allItems) {
        if (!item.trashed && !item.archived) {
            visibleItems.push({
                id: item.id,
                text: item.name ? item.name : item.getNamePlaceholder(rootStore.currentLocale),
                onClick: () => {
                    insertMention(view.state, view.dispatch, view, {
                        type: 'item',
                        targetId: item.id,
                        textInput: textInput,
                        nodePos: nodePos,
                    })
                },
                handleClose: () => {},
            })
        }
    }

    return (
        <ContextMenuInEditor
            headerText={intl.get('trigger-actions.type_to_filter').d('Type to filter')}
            isDark={isDark}
            itemGroups={[visibleItems]}
            onEmptyEnter={() => {
                const selection = (view.state.selection as TextSelection);
                view.dispatch(view.state.tr.insertText('\n', selection.$anchor.pos));
                return;
            }}
            handleClose={handleClose}
            isInline={true}
            filterQuery={textInput}
            maxWidth={'240px'}
        />
    )
}
